/**
 * Контракты аудита (E16 / И-8, НФТ-7, ФТ-7.3).
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

/** Типы действий аудита по клиентам. */
export const AUDIT_ACTION_TYPES = {
  CLIENT_SCHEDULE_DELETION: "client.schedule_deletion",
  CLIENT_CANCEL_DELETION: "client.cancel_deletion",
  CLIENT_ANNUL: "client.annul",
  CLIENT_ASSIGN_STAFF: "client.assign_staff",
  CLIENT_FINALIZE_DELETION: "client.finalize_deletion",
  CLIENT_UPDATE_MARKUP: "client.update_markup",
  PRICING_UPDATE_GLOBAL: "pricing.update_global",
  PRICING_CREATE_COMPONENT: "pricing.create_component",
  PRICING_UPDATE_BASE: "pricing.update_base",
} as const;

export type AuditActionType = (typeof AUDIT_ACTION_TYPES)[keyof typeof AUDIT_ACTION_TYPES];

export const AUDIT_OBJECT_TYPES = {
  CLIENT: "client",
  PRICE_SETTING: "price_setting",
  COMPONENT: "component",
} as const;

export type AuditObjectType = (typeof AUDIT_OBJECT_TYPES)[keyof typeof AUDIT_OBJECT_TYPES];

export const auditLogEntrySchema = z.object({
  id: z.string().uuid(),
  staffId: z.string().uuid().nullable(),
  actionType: z.string().min(1),
  objectType: z.string().nullable(),
  objectId: z.string().uuid().nullable(),
  details: z.record(z.unknown()).nullable(),
  createdAt: z.string().datetime(),
});
export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>;

export const auditLogListResponseSchema = apiSuccessSchema(z.array(auditLogEntrySchema));
